<layout>
    <div class="container">
        <h1>What to expect?</h1>

        <div class="choose">
            <app-second-card *ngFor="let c of content" 
                title={{c.title}} 
                body={{c.body}}
                icon={{c.icon}}
                color={{c.color}}
            ></app-second-card>
        </div>
    </div>
    
</layout>